import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

var userAgentPrefixMap = {
  tv: 'desktop',
  bigtablet: 'tablet',
  whitegoods: 'tablet',
  car: 'mobile',
  evalboard: 'mobile',
  phablet: 'mobile',
  player: 'mobile',
  console: 'mobile',
  reader: 'mobile',
  phone: 'mobile',
  smartphone: 'mobile',
  watch: 'mobile',
  glass: 'mobile',
  camera: 'mobile'
};
var devices;

(function (devices) {
  devices["desktop"] = "desktop";
  devices["tablet"] = "tablet";
  devices["mobile"] = "mobile";
})(devices || (devices = {}));

var fetchByContext = function fetchByContext(contextsMap, common, page) {
  var _page$pageData$id, _common$siteId, _common$ua$device$typ, _common$ua;

  var pageId = (_page$pageData$id = page === null || page === void 0 ? void 0 : page.pageData.id) !== null && _page$pageData$id !== void 0 ? _page$pageData$id : '';
  var siteId = (_common$siteId = common === null || common === void 0 ? void 0 : common.siteId) !== null && _common$siteId !== void 0 ? _common$siteId : 0;
  var deviceType = (_common$ua$device$typ = common === null || common === void 0 ? void 0 : (_common$ua = common.ua) === null || _common$ua === void 0 ? void 0 : _common$ua.device.type) !== null && _common$ua$device$typ !== void 0 ? _common$ua$device$typ : devices.mobile; // First priority is by pageId

  if (pageId && contextsMap.pages && contextsMap.pages[pageId]) {
    return getValue(contextsMap.pages[pageId], deviceType);
  } // Second priority is by siteId


  if (siteId && contextsMap.sites[siteId]) {
    return getValue(contextsMap.sites[siteId], deviceType);
  } // Last Priority is the default


  return getValue(contextsMap.sites["default"], deviceType);
};
var getValue = function getValue(entry, deviceType) {
  return hasDeviceKeys(entry) ? entry[getDeviceKeyByUserAgent(deviceType)] : entry;
};
var hasDeviceKeys = function hasDeviceKeys(entry) {
  return entry instanceof Object ? !!(entry !== null && entry !== void 0 && entry.mobile && entry !== null && entry !== void 0 && entry.desktop) : false;
};
var getDeviceKeyByUserAgent = function getDeviceKeyByUserAgent(deviceType) {
  var isMobile = standardizeDeviceType(deviceType) === devices.mobile;
  return isMobile ? devices.mobile : devices.desktop;
};
var standardizeDeviceType = function standardizeDeviceType(deviceType) {
  return deviceType.replace(new RegExp(Object.keys(userAgentPrefixMap).join('|'), 'gi'), function (matched) {
    return userAgentPrefixMap[matched.toLowerCase()];
  });
};

var CASINO_MAIN_CHART_PAGE_ID = '5e8d898b4b05a32144f6219c';
var CASINO_BONUSES_CHART_PAGE_ID = '5e9323098634e4903b7149cc';
var CASINO_BLACKJACK_CHART_PAGE_ID = '5e0de115505ccc965af5f6d4';
var CASINO_GAMBLING_CHART_PAGE_ID = '5e9302198634e496a671452e';
var LIVE_CASINO_CROSS_TO_SLOTS_CHART_PAGE_ID = '5eb020c5993bf70e74b488e6';
var SLOTS_MAIN_CHART_PAGE_ID = '5df8f7e3deaeef8305296eef';
var SLOTS_CHART_CROSS_IN_CASINO_PAGE_ID = '5e9d41acf4b60c0790cccaaf';
var SLOTS_CHART_CROSS_IN_BINGO_PAGE_ID = '5df8f85c57210d455608f4a8';
var VEGAS_CHART_CROSS_IN_BINGO_PAGE_ID = '5f61f3a50c20d0dc41c68e37';
var CASINO_CHART_CROSS_IN_BINGO_PAGE_ID = '5eca7dc8393a7cfa9224a95e';
var SLOTS_CHART_PAGE_IN_CASINO_PAGE_ID = '5e9563a18634e400aa71897a';
var SLOTS_PAGE_IN_CASINO_WIDGET_PAGE_ID = '5e9424344b05a37f52f68772';
var BLACKJACK_PAGE_IN_CASINO_WIDGET_PAGE_ID = '5e0dfa8a505ccc4f82f5fbbd';
var LIVE_CASINO_CHART_CROSS_IN_CASINO_PAGE_ID = '5e9c1fc6bcbdbc662f15c70a';
var LIVE_CASINO_CHART_CROSS_IN_BLACKJACK_PAGE_ID = '60132f28e9a18514701828cb';
var LIVE_CASINO_PAGE_IN_BLACKJACK_PAGE_ID = '6012a8b3a474ebb85a0aaed4';
var CASINO_PAGE_IN_SLOTS_WIDGET_PAGE_ID = '5eb00b11993bf7f9d9b4807b';
var BLACKJACK_CHART_CROSS_IN_CASINO_PAGE_ID = '5e9c311c2b1a036d2b7f4ebf';
var LIVE_CASINO_CHART_PAGE_IN_CASINO_PAGE_ID = '5e0de46b505cccdd82f5f79c';
var ROULETTE_CHART_PAGE_IN_CASINO_PAGE_ID = '5e9580318634e446cd718d3b';
var ROULETTE_CHART_PAGE_IN_BLACKJACK_PAGE_ID = '6012cb61e9a1856c3b181282';
var ROULETTE_PAGE_IN_BLACKJACK_PAGE_ID = '6013f25ba474eb25d40acd44';
var SPORT_AU_PRODUCT_POPUP_PAGE_ID = '6231e943d77fedb756f008db';
var ROULETTE_PAGE_IN_CASINO_WIDGET_PAGE_ID = '5e11c37c57210de30f09b14d';
var SPORT_CHART_CROSS_IN_CASINO_PAGE_ID = '5fd87e806a310a5ba55470ea';
var ROULETTE_CHART_CROSS_IN_CASINO_PAGE_ID = '5e9c22ccf4b60ce9a7cc8f48';
var SLOTS_VEGAS_CHART_PAGE_ID = '5f47c49b0c20d0781cc3d401';
var SLOTS_VEGAS_CROSS_PAGE_ID = '5f47d1aa0c20d04375c3dcf0';
var RAINBOW_CHART_PAGE_IN_SLOTS_PAGE_ID = '5eb26b878bf4b415423f13a4';
var BINGO_BONUSES_PAGE_ID = '5ec27e54393a7ca70d23fce5';
var BINGO_MAIN_PAGE_ID = '5dc95b2e8e8faa2b324658f4';
var BINGO_NON_DEPOSIT_PAGE_ID = '5ec282a48bf4b4ff183fffe2';
var SLOTS_CASINO_BONANZA_GAME_ID = '5eb144528bf4b49ce63ef11c';
var SLOTS_CASINO_RAINBOW_RICHES_GAME_ID = '5eba6b1aa621adefb5850cef';
var SLOTS_CASINO_STARBURST_GAME_ID = '5eba706f393a7cc8dd2335a4';
var SLOTS_CASINO_EYE_OF_HOURS_GAME_ID = '5eba71c78bf4b4cb8d3f6fc0';
var SLOTS_CASINO_FLUFFY_FAVOURITES_GAME_ID = '5eba79cea621ad0453850eed';
var SLOTS_CASINO_FISHIN_FRENZY_GAME_ID = '5eba8e82393a7c19ff23382f';
var SLOTS_CASINO_WIZARD_OF_OZ_GAME_ID = '5eba994ea621adc703851307';
var SLOTS_CASINO_CLEOPATRA_GAME_ID = '5eba9a6c8bf4b44c7a3f7452';
var SLOTS_CASINO_MONOPOLY_GAME_ID = '5eba9b688bf4b4c75e3f74c1';
var SLOTS_CASINO_DOUBLE_BUBBLE_GAME_ID = '5eba9c6ca621ad9be48513e3';
var SPORT_MAIN_PAGE_ID = '5fd0a8f298bb985904662d9b';
var SPORT_ONLINE_CASINO_PAGE_ID = '5ff2fe2e1586f61468dcbd2e';
var CASINO_CHART_CROSS_IN_SPORT_PAGE_ID = '5ffc092c26a1d03cbb02202f';
var CASINO_CHART_CROSS_IN_BLACKJACK_PAGE_ID = '60140d6ce4c7d5ed14203618';
var ROULETTE_CHART_CROSS_IN_SPORT_PAGE_ID = '5ffc14651586f6e713e2db07';
var SLOTS_CHART_CROSS_IN_SPORT_PAGE_ID = '5ffc35e01586f6255ce32ae4';
var SLOTS_CHART_CROSS_IN_BLACKJACK_PAGE_ID = '6012b9c8a474eb20670abb07';
var SLOTS_CHART_PAGE_IN_BLACKJACK_PAGE_ID = '6012bf69e9a18577b0180ff0';
var SPORT_VIRTUAL_SPORTS_PAGE_ID = '5ff407ca1586f607f4dcfebd';
var SPORT_ONLINE_CASINO_CROSS_CHART = '5ffd64bea54beabc45721faf';
var SPORT_FR_HORSE_CHART_PAGE = '60093edba54bea16057541bf';
var SPORT_FR_MAIN_PAGE_ID = '60093a061586f6c0d0e73da7';
var CASINO_TAB_IN_POKER = '601bc0ca9bc1395a3499bfa0';
var BLACKJACK_TAB_IN_POKER = '601bbde2e9ba91c00093fe6e';
var SLOTS_TAB_IN_POKER = '601bbf2f8d7f0001e879f250';
var CASINO_CHART_CROSS_IN_ROULETTE_PAGE_ID = '6017f2303ad81db3e5d172af';
var BLACKJACK_CROSS_IN_POKER_DT = '6007f05aa54beaa2f374fae8';
var LIVECASINO_CROSS_IN_POKER_DT = '601a82786c3a8d03f77f4a6a';
var SLOTS_CHART_CROSS_IN_CASINO_GAMBLING_ID = '5ed4a3d28bf4b41dc34171bf';
var LIVECASINO_CHART_CROSS_IN_CASINO_GAMBLING_ID = '5f840a7d15906e3cb5414316';
var CASINO_RO_MAIN_CHART_PAGE_ID = '6024ebf241e77244ae91ee00';
var CASINO_CHART_CROSS_IN_SPORT_RO_PAGE_ID = '602b9f604a1a528193c56a14';
var SPORT_CHAMPIONS_LEAGUE_CHART_PAGE_ID = '6032460dd7c3ff0ee667d56d';
var CASINO_RO_MID_CHART_IN_SPORT_RO_PAGE_ID = '602a63b58d7f00746f7a0991';
var CASINO_RO_CROSS_IN_SPORT_RO_PAGE_ID = '602b9f604a1a528193c56a14';
var GAMBLING_CHART_IN_CASINO_RO = '602935033e26c241ba00cc15';
var LIVE_CASINO_CHART_IN_CASINO_RO = '60293a403e26c2efb500cc7f';
var SLOTS_CHART_IN_CASINO_RO = '602942979bc1396b0d99d22a';
var SLOTS_UK_MID_CHART_IN_BINGO_PAGE_ID = '6065bad4833cdb161faa7018';
var PGR_PPC_PAGE_ID = '5e148040c8339b0b6267ff03';
var SPORT_UK_PREMIER_LEAGUE_PAGE_ID = '5ff32c6626a1d0cb38fc422f';
var GAMBLING_UK_MAIN_CHART_PAGE_ID = '60c1e39f94cc09046af9f9ec';
var CASINO_CROSS_IN_SPORT_PT_PAGE_ID = '60c7548153340afae204c0fb';
var MID_CHART_CASINO_IN_SPORT_PAGE_ID = '6005aa211586f65fede6dece';
var MID_CHART_SLOTS_IN_BINGO_PAGE_ID = '6065bad4833cdb161faa7018';
var ONLINE_CASINOS_UK_CHART_PAGE_ID = '60fd4882494b246c1924d84e';
var CASINO_UK_COMPARISON_NICHE_PAGE_ID = '611b772303cc70fe4b365855';
var SLOTS_RO_MAIN_CHART_PAGE_ID = '612619b524aad66966088693';
var SLOTS_UK_PAGE_IN_GAMBLING_PAGE_ID = '614ac68f494b2406502766c6';
var SLOTS_UK_VEGAS_CROSS_IN_CASINO_BONUSES_PAGE_ID = '61502984494b241ca327b3a6';
var BINGO_CHART_CROSS_IN_GAMBLING_PAGE_ID = '614b28fb95ab4c6fc408ff21';
var SLINGO_CHART_PAGE_ID = '613b04f724aad6d216091139';
var FOOTBALL_CHART_PAGE_ID = '6139f5a395ab4c388a0881ab';
var HORSE_RACING_CHART_PAGE_ID = '6139f6ba95ab4c18ef0882b5';
var SLOTS_CROSS_IN_GAMBLING_PAGE_ID = '617142cd608bebe782ba25af';
var LIVE_CASINO_CROSS_RO_CROSS_IN_CASINO_RO_PAGE_ID = '618a650adaba29321d0e772e';
var SLOTS_RO_CROSS_IN_CASINO_RO_PAGE_ID = '618a6e35608beb4a34bb2d01';
var VEGAS_CROSS_IN_SLOTS_RO_PAGE_ID = '618ba0b706940aa583016d58';
var CASINO_RO_CROSS_IN_SLOTS_RO_PAGE_ID = '618bab26608beb7f7cbb3c18';
var CASINO_UK_DEPOSIT_MATCH_CROSS_PAGE_ID = '61a7679fdaba293b560f80f4';
var CASINO_UK_NO_WAGERING_CROSS_PAGE_ID = '61a766a906940a9ca30275a4';
var CASINO_SE_SPORT_BETTING_INNER_CHART_PAGE_ID = '620647351c01e63d32997157';
var SLOTS_UK_BONUSES_PAGE_ID = '6139cc8895ab4c15ba087854';
var SLOTS_UK_MID_CHART_IN_BINGO_UK_PAGE_ID = '6218c0d23dab10108c0199e1';
var SPORT_RO_ONLINE_CASINO_INNER_CHART_PAGE_ID = '625fb9b736c8f14f82ac3a97';

var BINGO_UK_SITE_ID = 119;
var SPORT_UK_SITE_ID = 116;
var SPORT_FR_SITE_ID = 215;
var CASINO_UK_SITE_ID = 130;
var SLOTS_UK_SITE_ID = 242;
var POKER_UK_SITE_ID = 177;
var ROULETTE_UK_SITE_ID = 254;
var BLACKJACK_UK_SITE_ID = 252;
var RUMMY_IN_SITE_ID = 10124;
var PGR_SITE_ID = 10101;
var CASINO_RO_SITE_ID = 10088;
var SPORT_RO_SITE_ID = 10091;
var SPORT_DE_SITE_ID = 10138;
var SPORT_PT_SITE_ID = 10140;
var GAMBLING_UK_SITE_ID = 10136;
var PGS_SITE_ID = 10134;
var SLOTS_RO_SITE_ID = 10145;
var CASINO_NL_SITE_ID = 10147;
var CASINO_SE_SITE_ID = 10069;
var CASINO_CA_SITE_ID = 10186;
var SPORT_AU_SITE_ID = 10028;

var _sites;
var getSiteName = function getSiteName() {
  var common = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return fetchByContext(siteNamesMap, common);
};
var siteNamesMap = {
  sites: (_sites = {}, _defineProperty(_sites, BINGO_UK_SITE_ID, 'bingo'), _defineProperty(_sites, SPORT_UK_SITE_ID, 'sport'), _defineProperty(_sites, CASINO_UK_SITE_ID, 'casino'), _defineProperty(_sites, SLOTS_UK_SITE_ID, 'slots'), _defineProperty(_sites, POKER_UK_SITE_ID, 'poker'), _defineProperty(_sites, ROULETTE_UK_SITE_ID, 'roulette'), _defineProperty(_sites, BLACKJACK_UK_SITE_ID, 'blackjack'), _defineProperty(_sites, "default", ''), _sites)
};

export { BINGO_BONUSES_PAGE_ID, BINGO_CHART_CROSS_IN_GAMBLING_PAGE_ID, BINGO_MAIN_PAGE_ID, BINGO_NON_DEPOSIT_PAGE_ID, BINGO_UK_SITE_ID, BLACKJACK_CHART_CROSS_IN_CASINO_PAGE_ID, BLACKJACK_CROSS_IN_POKER_DT, BLACKJACK_PAGE_IN_CASINO_WIDGET_PAGE_ID, BLACKJACK_TAB_IN_POKER, BLACKJACK_UK_SITE_ID, CASINO_BLACKJACK_CHART_PAGE_ID, CASINO_BONUSES_CHART_PAGE_ID, CASINO_CA_SITE_ID, CASINO_CHART_CROSS_IN_BINGO_PAGE_ID, CASINO_CHART_CROSS_IN_BLACKJACK_PAGE_ID, CASINO_CHART_CROSS_IN_ROULETTE_PAGE_ID, CASINO_CHART_CROSS_IN_SPORT_PAGE_ID, CASINO_CHART_CROSS_IN_SPORT_RO_PAGE_ID, CASINO_CROSS_IN_SPORT_PT_PAGE_ID, CASINO_GAMBLING_CHART_PAGE_ID, CASINO_MAIN_CHART_PAGE_ID, CASINO_NL_SITE_ID, CASINO_PAGE_IN_SLOTS_WIDGET_PAGE_ID, CASINO_RO_CROSS_IN_SLOTS_RO_PAGE_ID, CASINO_RO_CROSS_IN_SPORT_RO_PAGE_ID, CASINO_RO_MAIN_CHART_PAGE_ID, CASINO_RO_MID_CHART_IN_SPORT_RO_PAGE_ID, CASINO_RO_SITE_ID, CASINO_SE_SITE_ID, CASINO_SE_SPORT_BETTING_INNER_CHART_PAGE_ID, CASINO_TAB_IN_POKER, CASINO_UK_COMPARISON_NICHE_PAGE_ID, CASINO_UK_DEPOSIT_MATCH_CROSS_PAGE_ID, CASINO_UK_NO_WAGERING_CROSS_PAGE_ID, CASINO_UK_SITE_ID, FOOTBALL_CHART_PAGE_ID, GAMBLING_CHART_IN_CASINO_RO, GAMBLING_UK_MAIN_CHART_PAGE_ID, GAMBLING_UK_SITE_ID, HORSE_RACING_CHART_PAGE_ID, LIVECASINO_CHART_CROSS_IN_CASINO_GAMBLING_ID, LIVECASINO_CROSS_IN_POKER_DT, LIVE_CASINO_CHART_CROSS_IN_BLACKJACK_PAGE_ID, LIVE_CASINO_CHART_CROSS_IN_CASINO_PAGE_ID, LIVE_CASINO_CHART_IN_CASINO_RO, LIVE_CASINO_CHART_PAGE_IN_CASINO_PAGE_ID, LIVE_CASINO_CROSS_RO_CROSS_IN_CASINO_RO_PAGE_ID, LIVE_CASINO_CROSS_TO_SLOTS_CHART_PAGE_ID, LIVE_CASINO_PAGE_IN_BLACKJACK_PAGE_ID, MID_CHART_CASINO_IN_SPORT_PAGE_ID, MID_CHART_SLOTS_IN_BINGO_PAGE_ID, ONLINE_CASINOS_UK_CHART_PAGE_ID, PGR_PPC_PAGE_ID, PGR_SITE_ID, PGS_SITE_ID, POKER_UK_SITE_ID, RAINBOW_CHART_PAGE_IN_SLOTS_PAGE_ID, ROULETTE_CHART_CROSS_IN_CASINO_PAGE_ID, ROULETTE_CHART_CROSS_IN_SPORT_PAGE_ID, ROULETTE_CHART_PAGE_IN_BLACKJACK_PAGE_ID, ROULETTE_CHART_PAGE_IN_CASINO_PAGE_ID, ROULETTE_PAGE_IN_BLACKJACK_PAGE_ID, ROULETTE_PAGE_IN_CASINO_WIDGET_PAGE_ID, ROULETTE_UK_SITE_ID, RUMMY_IN_SITE_ID, SLINGO_CHART_PAGE_ID, SLOTS_CASINO_BONANZA_GAME_ID, SLOTS_CASINO_CLEOPATRA_GAME_ID, SLOTS_CASINO_DOUBLE_BUBBLE_GAME_ID, SLOTS_CASINO_EYE_OF_HOURS_GAME_ID, SLOTS_CASINO_FISHIN_FRENZY_GAME_ID, SLOTS_CASINO_FLUFFY_FAVOURITES_GAME_ID, SLOTS_CASINO_MONOPOLY_GAME_ID, SLOTS_CASINO_RAINBOW_RICHES_GAME_ID, SLOTS_CASINO_STARBURST_GAME_ID, SLOTS_CASINO_WIZARD_OF_OZ_GAME_ID, SLOTS_CHART_CROSS_IN_BINGO_PAGE_ID, SLOTS_CHART_CROSS_IN_BLACKJACK_PAGE_ID, SLOTS_CHART_CROSS_IN_CASINO_GAMBLING_ID, SLOTS_CHART_CROSS_IN_CASINO_PAGE_ID, SLOTS_CHART_CROSS_IN_SPORT_PAGE_ID, SLOTS_CHART_IN_CASINO_RO, SLOTS_CHART_PAGE_IN_BLACKJACK_PAGE_ID, SLOTS_CHART_PAGE_IN_CASINO_PAGE_ID, SLOTS_CROSS_IN_GAMBLING_PAGE_ID, SLOTS_MAIN_CHART_PAGE_ID, SLOTS_PAGE_IN_CASINO_WIDGET_PAGE_ID, SLOTS_RO_CROSS_IN_CASINO_RO_PAGE_ID, SLOTS_RO_MAIN_CHART_PAGE_ID, SLOTS_RO_SITE_ID, SLOTS_TAB_IN_POKER, SLOTS_UK_BONUSES_PAGE_ID, SLOTS_UK_MID_CHART_IN_BINGO_PAGE_ID, SLOTS_UK_MID_CHART_IN_BINGO_UK_PAGE_ID, SLOTS_UK_PAGE_IN_GAMBLING_PAGE_ID, SLOTS_UK_SITE_ID, SLOTS_UK_VEGAS_CROSS_IN_CASINO_BONUSES_PAGE_ID, SLOTS_VEGAS_CHART_PAGE_ID, SLOTS_VEGAS_CROSS_PAGE_ID, SPORT_AU_PRODUCT_POPUP_PAGE_ID, SPORT_AU_SITE_ID, SPORT_CHAMPIONS_LEAGUE_CHART_PAGE_ID, SPORT_CHART_CROSS_IN_CASINO_PAGE_ID, SPORT_DE_SITE_ID, SPORT_FR_HORSE_CHART_PAGE, SPORT_FR_MAIN_PAGE_ID, SPORT_FR_SITE_ID, SPORT_MAIN_PAGE_ID, SPORT_ONLINE_CASINO_CROSS_CHART, SPORT_ONLINE_CASINO_PAGE_ID, SPORT_PT_SITE_ID, SPORT_RO_ONLINE_CASINO_INNER_CHART_PAGE_ID, SPORT_RO_SITE_ID, SPORT_UK_PREMIER_LEAGUE_PAGE_ID, SPORT_UK_SITE_ID, SPORT_VIRTUAL_SPORTS_PAGE_ID, VEGAS_CHART_CROSS_IN_BINGO_PAGE_ID, VEGAS_CROSS_IN_SLOTS_RO_PAGE_ID, fetchByContext, getDeviceKeyByUserAgent, getSiteName, getValue, hasDeviceKeys, standardizeDeviceType };
